import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Banknote } from 'lucide-react';
import { CircleFlag } from 'react-circle-flags';
import { getCurrencySymbol, getCountryCode } from '../../../config/currencies';

interface CurrencyTotal {
  currency: string;
  amount: number;
}

interface MultiCurrencyTotalProps {
  currencyTotals: CurrencyTotal[];
}

export const MultiCurrencyTotal: React.FC<MultiCurrencyTotalProps> = ({ currencyTotals }) => {
  if (currencyTotals.length === 0) {
    return (
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Total Expenses</CardTitle>
          <Banknote className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent className="flex items-center justify-center py-6">
          <div className="text-4xl font-bold">$0.00</div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">Total Expenses</CardTitle>
        <Banknote className="h-4 w-4 text-muted-foreground" />
      </CardHeader>
      <CardContent className="py-4">
        <div className="space-y-3">
          {currencyTotals.map(({ currency, amount }) => (
            <div key={currency} className="flex items-center justify-between gap-2 min-w-0">
              <div className="flex items-center gap-2 flex-shrink-0">
                <CircleFlag
                  countryCode={getCountryCode(currency)}
                  height="28"
                  width="28"
                />
                <span className="text-sm font-medium text-muted-foreground">{currency}</span>
              </div>
              <div className="text-lg md:text-2xl font-bold truncate">
                {getCurrencySymbol(currency)} {amount.toFixed(2)}
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
